import ShoppingListPlaceholder from './Placeholder/ShoppingListPlaceholder';
import { useTranslator, withLoading } from '@front-activerse/common-components';
import ShoppingListContainer from './ShoppingListContainer';
import NoDiet from './Content/NoDiet';
import Layout from '../Layout/Layout';
import TitleBar from '../Layout/TitleBar';

const ShoppingListIndexContainer = ({
  shoppingList,
  handleMarkProduct,
  loadShoppingList,
  availableDays,
  loading,
  period,
  refetch,
  fetchShoppingListOnDemand,
  loadingOnDemand,
  shoppingTipsArticleId,
}) => {
  const { t } = useTranslator();

  return (
    <Layout>
      <TitleBar>{t('shoppingList.navbarTitle')}</TitleBar>
      <div className="page-template-shopping-list full-height3a">
        {!shoppingList ? (
          <NoDiet />
        ) : (
          <ShoppingListContainer
            handleMarkProduct={handleMarkProduct}
            loadShoppingList={loadShoppingList}
            availableDays={availableDays}
            shoppingList={shoppingList}
            loading={loading}
            period={period}
            refetch={refetch}
            fetchShoppingListOnDemand={fetchShoppingListOnDemand}
            loadingOnDemand={loadingOnDemand}
            shoppingTipsArticleId={shoppingTipsArticleId}
          />
        )}
      </div>
    </Layout>
  );
};

export { ShoppingListIndexContainer };

export default withLoading(ShoppingListIndexContainer, ShoppingListPlaceholder);
